import apiSlice from "@/redux/slice/api";
import routerSlice from "@redux/slice/router";
import userSlice from "@redux/slice/user";
import { configureStore } from "@reduxjs/toolkit";
import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";

const store = configureStore({
  reducer: {
    user: userSlice,
    api: apiSlice,
    router: routerSlice,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;

// Usage:
// this is how to get this data in a component
// const app = useAppSelector((state) => state.app)
// this is how to edit this data in a component
// const dispatch = useAppDispatch()
// dispatch(test({ totalBatch: 5 }))
